import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import App from "./App";
import { ProjectPage } from "./Components/ProjectPage";
import { createClient } from '@supabase/supabase-js'
import { ImageSegmentation } from "./Components/Pages/ImageSegmentation";
import { ConnectedComponets } from "./Components/Pages/ConnectedComponets";
import { GeometricFeatureComputation } from "./Components/Pages/GeometricFeatureComputation";
import { CornerDetection } from "./Components/Pages/CornerDetection";
import { EdgeDetection } from "./Components/Pages/EdgeDetection";
import { HistogramEqualization } from "./Components/Pages/HistogramEqualization";
import ProjectNotAvailable from "./Components/Pages/Error/ProjectNotAvailable";
import { QueryClient } from '@tanstack/react-query';
import SocketFileTransfer from "./Components/Pages/Networking/SocketFileTransfer";
import EnhancedClientCommunication from "./Components/Pages/Networking/EnhancedClientCommunication";
import Providers from "./Providers";


const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY
const queryClient = new QueryClient();

export const supabase = createClient(`${supabaseUrl}`, supabaseKey)
export const router = createBrowserRouter([
    {
      path: "/",
      element: 
      <Providers >
        <App />
      </Providers>,
      errorElement: <ProjectNotAvailable />,
    },

    {
        path: "/Project/Image Segmentation",
      element: 
      <Providers >
          <ImageSegmentation />
      </Providers>
    },

    {
      path: "/Project/Connected Components",
      element: 
      <Providers >
        <ConnectedComponets />
      </Providers>
      
    },

    {
      path: "/Project/Geo-Feature Computation",
      element: 
      <Providers >
        <GeometricFeatureComputation />
      </Providers>
    },

    {
      path: "/Project/Corner Detection",
      element: 
      <Providers >
        <CornerDetection />
      </Providers>
    },

    {
      path: "/Project/Edge Detection",
      element: 
      <Providers >
        <EdgeDetection />
      </Providers>
    },

    {
      path: "/Project/Histogram Equalization",
      element: 
      <Providers >
        <HistogramEqualization />
      </Providers>
    },

    {
      path: "/Project/Socket File Transfer",
      element: 
      <Providers >
        <SocketFileTransfer />
      </Providers>
    },

    {
      path: "/Project/Enhanced CLient Communication",
      element: 
      <Providers >
        <EnhancedClientCommunication />
      </Providers>
    },

  ]);

